import { Dimensions, RingConfiguration } from '@ringo/types'
import { SinterringRingDetailsBuilder } from './sinteringDetailsBuilder'
import { NumberFormatter, RingDetailsBuilder, TranslationFunc } from './ringDetailsBuilder'
import { isSinterring } from '../profileHelper'
import { AlloyDTO } from '../../generated'

export function getRingDetailsBuilder(
    ring: RingConfiguration,
    visibleFields: Array<keyof Dimensions>,
    t: TranslationFunc,
    lang: 'en' | 'de',
    alloys: AlloyDTO[],
    formatCurrency: (number: number) => string,
    formatNumber: NumberFormatter
): RingDetailsBuilder {
    if (isSinterring(ring.activeProfile)) {
        return new SinterringRingDetailsBuilder(ring, visibleFields, t, lang, alloys, formatCurrency, formatNumber)
    }

    return new RingDetailsBuilder(ring, visibleFields, t, lang, alloys, formatCurrency, formatNumber)
}
